export const formatText = (str: string) => {
  if (str) {
    if (str === "event_not_occured" || str === "event_not_occurred") {
      return "Event Not Occurred";
    }
    const arr = str && str.split("_");
    const result = [];
    for (const word of arr) {
      result.push(
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // 👈️ lowercase remainder
      );
    }
    return result.join(" ");
  } else {
    return "";
  }
};

export const formatSmallString = (str: string) => {
  let length = str ? str.length : 0;
  return length > 30 ? str.substring(0, 30).concat("...") : str;
};

export const convertStringToNumber = (str: string) => {
  return str ? parseInt(str) : str;
};

export const getFirstLetter = (str: string) => {
  return str ? str.charAt(0).toUpperCase() : str;
};

export const formatString = (str: any) => {
  if (str) {
    if (str === "event_not_occured" || str === "event_not_occurred") {
      return "Event Not Occurred";
    }
    return str.replace(/\b\w/g, (match: any) => match.toUpperCase());
  } else {
    return "";
  }
};
